import { useServiceWorkerUpdate } from '../hooks/useServiceWorkerUpdate.js';

/**
 * 129: shown once `useServiceWorkerUpdate` reports a new service worker has taken control of this
 * tab. `sticky top-0` lives on the shared wrapper in `main.tsx`, not here — critique found two
 * independently-sticky global banners collide with each other once scrolled (both pinned to the
 * same `top: 0`), the same class of bug `ImpersonationBanner.tsx`'s own 078 fix already solved
 * once, just between a banner and page content rather than two banners.
 */
export function UpdateToast() {
  const updateAvailable = useServiceWorkerUpdate();
  if (!updateAvailable) return null;

  return (
    <output class="flex items-center justify-between gap-3 bg-secondary px-4 py-2 text-sm font-medium text-on-secondary shadow-md">
      <span>A new version is available.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        class="shrink-0 rounded-full bg-black px-3 py-1 text-xs font-semibold text-on-secondary hover:opacity-90"
      >
        Reload
      </button>
    </output>
  );
}
